import $ from 'jquery';

// Navbar scrolling effect
let lastScroll = 0;
let navHeight = $('.navbar-main-container').outerHeight();

$(function () {
    const stickyNavbar = function () {
        let nowScroll = $(window).scrollTop();
        let alertHeight = 0;

        $('.navbar-spacer').height(navHeight);

        if ($('.alert').length !== 0) {
            alertHeight = $('.alert').outerHeight();
        }

        if (nowScroll > navHeight + alertHeight && nowScroll > lastScroll) {
            $('.navbar-main-container').addClass('scroll-down');
            lastScroll = nowScroll;
        } else if (nowScroll < lastScroll - 100) {
            $('.navbar-main-container').removeClass('scroll-down');
            $('.navbar-main-container').addClass('sticky-nav');
            $('.navbar-spacer').removeClass('d-none');
            lastScroll = nowScroll;
        }

        if (nowScroll <= alertHeight) {
            if ($('.navbar-collapse').hasClass('show')) {
                return;
            }
            $('.navbar-main-container').removeClass('sticky-nav');
            $('.navbar-spacer').addClass('d-none');
        }

        if (nowScroll <= alertHeight + navHeight) {
            $('.navbar-main-container').removeClass('scroll-down');
        }
    };

    if ($(window).width() < 1400) {
        stickyNavbar();

        $(window).on('scroll', () => {
            stickyNavbar();
        });
    }

    $(window).on('resize', function () {
        if ($(window).width() < 1400) {
            stickyNavbar();

            $(window).on('scroll', () => {
                stickyNavbar();
            });
        } else {
            $('.navbar-spacer').addClass('d-none');
            $(window).off('scroll');
        }
    });
});
